import type { ChordName } from '../../../core/theory';
import { defineSong } from '../types';

// The recording is in 4/4 at 150 BPM and the chord changes every two beats, so one bar here is two beats.
// The riff progression carries the intro, the verses, both interludes and the guitar solo.
const riff: ChordName[] = ['Bm', 'G', 'A', 'Em', 'Bm', 'G', 'A', 'A', 'Bm', 'G', 'A', 'Em', 'G', 'A', 'Bm', 'Bm'];
const preChorus: ChordName[] = ['G', 'A', 'Bm', 'Bm', 'G', 'G', 'G', 'G', 'A', 'A', 'A', 'A'];
const cadence: ChordName[] = ['Bm', 'G', 'Em', 'F#'];
const chorus: ChordName[] = [...cadence, ...cadence, ...cadence, 'G', 'G', 'G', 'G', 'A', 'A', 'A', 'A'];

export default defineSong({
  id: 'bu-aksam',
  title: 'Bu Akşam',
  level: 3,
  key: 'Bm',
  bpm: 150,
  beats: 2,
  pattern: 'D-DU',
  style: 'Türk rock',
  desc: "{{pc:B}} minörde i–VI–VII–iv dönüyor ve akorlar iki vuruşta bir değişiyor: bası takip et. Nakaratta iv'ün ardından gelen majör V, yani {{c:F#}}, seni yeniden toniğe çekiyor.",
  sections: [
    { name: 'Giriş', bars: [...riff, ...riff] },
    { name: 'Kıta', bars: [...riff] },
    { name: 'Ara', bars: [...riff] },
    { name: 'Kıta', bars: [...riff] },
    { name: 'Köprü', bars: [...preChorus] },
    { name: 'Nakarat', bars: [...chorus] },
    { name: 'Ara', bars: [...riff, ...riff] },
    { name: 'Kıta', bars: [...riff] },
    { name: 'Köprü', bars: [...preChorus] },
    { name: 'Nakarat', bars: [...chorus] },
    { name: 'Nakarat', bars: [...chorus] },
    { name: 'Son', bars: ['Bm'] },
  ],
  cover: {
    artist: 'Duman',
    references: [
      'https://www.songsterr.com/a/wsa/duman-bu-aksam-tab-s30551',
      'https://www.repertuarim.com/akor/duman-bu-aksam-akor-802.html',
    ],
    year: 2002,
    listen: 'https://open.spotify.com/track/6jo5kjABNphNwXQ8ZyOLtZ',
  },
});
